module.exports = __webpack_public_path__ + "img/pz.0ee17da3.svg";